module.exports = __webpack_public_path__ + "img/eb05e4050c4b82a4d4bbd39c122a6ade-newLogo1.png";